import * as tslib_1 from "tslib";
import { jsonArrayMember, jsonMember, jsonObject } from 'typedjson';
import { BdpkObject } from '../../bdpk-objects/domain/bdpk-object';
let BdpkFolder = class BdpkFolder {
    constructor() {
        this.privileges = [];
        this._objects = [];
    }
    get id() {
        return this._id;
    }
    set id(value) {
        this._id = value;
    }
    get parentId() {
        return this._parentId;
    }
    set parentId(value) {
        this._parentId = value;
    }
    get name() {
        return this._name;
    }
    set name(value) {
        this._name = value;
    }
    get ord() {
        return this._ord;
    }
    set ord(value) {
        this._ord = value;
    }
    get analyticalTaskId() {
        return this._analyticalTaskId;
    }
    set analyticalTaskId(value) {
        this._analyticalTaskId = value;
    }
    get description() {
        return this._description;
    }
    set description(value) {
        this._description = value;
    }
    get isVisible() {
        return this._isVisible;
    }
    set isVisible(value) {
        this._isVisible = value;
    }
    get imagePath() {
        return this._imagePath;
    }
    set imagePath(value) {
        this._imagePath = value;
    }
    get objects() {
        return this._objects;
    }
    set objects(value) {
        this._objects = value;
    }
};
tslib_1.__decorate([
    jsonMember({ name: "id", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], BdpkFolder.prototype, "_id", void 0);
tslib_1.__decorate([
    jsonMember({ name: "parentId", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], BdpkFolder.prototype, "_parentId", void 0);
tslib_1.__decorate([
    jsonMember({ name: "name", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], BdpkFolder.prototype, "_name", void 0);
tslib_1.__decorate([
    jsonMember({ name: "ord", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], BdpkFolder.prototype, "_ord", void 0);
tslib_1.__decorate([
    jsonMember({ name: "analyticalTaskId", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], BdpkFolder.prototype, "_analyticalTaskId", void 0);
tslib_1.__decorate([
    jsonMember({ name: "description", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], BdpkFolder.prototype, "_description", void 0);
tslib_1.__decorate([
    jsonMember({ name: "isVisible", constructor: Boolean, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Boolean)
], BdpkFolder.prototype, "_isVisible", void 0);
tslib_1.__decorate([
    jsonMember({ name: "imagePath", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], BdpkFolder.prototype, "_imagePath", void 0);
tslib_1.__decorate([
    jsonArrayMember(Number, { emitDefaultValue: false, preserveNull: false, isRequired: false }),
    tslib_1.__metadata("design:type", Array)
], BdpkFolder.prototype, "privileges", void 0);
tslib_1.__decorate([
    jsonArrayMember(BdpkObject, { name: "objects", emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Array)
], BdpkFolder.prototype, "_objects", void 0);
BdpkFolder = tslib_1.__decorate([
    jsonObject
], BdpkFolder);
export { BdpkFolder };
